import { ThemeProvider } from '@nivo/core';
import React from 'react';

const themeSettings = {
  background: '#FFFFFF',
  textColor: '#161616',
  fontSize: 12,
  axis: {
    ticks: {
      line: {
        strokeWidth: 1,
        stroke: '#C4C4C4',
      },
      text: {
        fontSize: 14,
        fill: '#595959',
      },
    },
    domain: {
      line: {
        strokeWidth: 1,
        stroke: '#C4C4C4',
      },
    },
  },
  grid: {
    line: {
      strokeWidth: 0,
    },
  },
};

export const NivoProvider: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => (
  <ThemeProvider theme={themeSettings}>{children}</ThemeProvider>
);
